import React from 'react';
import { Title, Text, Button, Header } from 'ui';
import { useAuth, updatePage } from 'api';
import { useParams, useHistory } from 'react-router-dom';
import { lightBlue } from 'config/colors';

export default function TagType(props) {
  
  // Load the tag.
  
  const auth = useAuth();
  const history = useHistory();
  const companyId = auth ? auth.company.id : null;
  const {pageId} = useParams();
  
  
  // Set type.
  
  async function useDesigner() {
    await updatePage(companyId, pageId, {
      type: 'design'
    });
    history.push('view');
  }
  
  async function useCode() {
    await updatePage(companyId, pageId, {
      type: 'code'
    });
    history.push('view');
  }
  
  async function useExperience() {
    await updatePage(companyId, pageId, {
      type: 'experience'
    });
    history.push('view');
  }
  
  
  // Render
  
  return (
    <div>
      <Header>
        <Text large light style={{flex:1}}>Choose a Method</Text>
      </Header>
      
      <div style={{padding:"100px 24px 40px 24px"}}>
        <div style={{margin:'0 auto', display:'flex', justifyContent:'center'}}>
          <Button onClick={useCode} backgroundColor="#ffffff" style={{height:300, margin:16, padding:24, flex:'0 1 300px', display:'flex', flexDirection:'column', alignItems:'stretch'}}>
            <Title bold color={lightBlue} style={{marginBottom:24}}>Code Your Own</Title>
            <Text>Write or copy HTML and CSS directly into our platform to conncet a landing page to your campaigns</Text>
            <div style={{flex:1}}/>
            <Button backgroundColor={lightBlue} style={{textAlign:'center', color:'white'}}>Select</Button>
          </Button>
          <Button onClick={useDesigner} backgroundColor="#ffffff" style={{height:300, margin:16, padding:24, flex:'0 1 300px', display:'flex', flexDirection:'column', alignItems:'stretch'}}>
            <Title bold color={lightBlue} style={{marginBottom:24}}>Use GrapesJS</Title>
            <Text>A web builder framework which combines different tools and features to help you to build HTML templates with little knowledge of coding.</Text>
            <div style={{flex:1}}/>
            <Button backgroundColor={lightBlue} style={{textAlign:'center', color:'white'}}>Select</Button>
          </Button>
          <Button onClick={useExperience} backgroundColor="#ffffff" style={{height:300, margin:16, padding:24, flex:'0 1 300px', display:'flex', flexDirection:'column', alignItems:'stretch'}}>
            <Title bold color={lightBlue} style={{marginBottom:24}}>Use our design tools</Title>
            <Text>Design interactive, mobile optimized landing pages with our simple experience builder.</Text>
            <div style={{flex:1}}/>
            <Button backgroundColor={lightBlue} style={{textAlign:'center', color:'white'}}>Select</Button>
          </Button>
        </div>
      </div>
      
    </div>
  );
}